export default __webpack_public_path__ + "static/media/01f_fold-6.41c759dd.mp4";